module.exports = __webpack_public_path__ + "img/TRANSITIONS-SIGNATURE-3.4587a2ae.gif";